import React, { FC, useState } from 'react';
import { Button, Modal } from 'antd';
import { Divider, IconBackground, SearchInput } from 'common/components';
import { DEFAULT_VALUE_0 } from 'common/config';
import { Delivery, Plus } from 'common/svg';
import { EColor } from 'common/const';
import { IAddress } from 'entities/Address/Address.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  list: IAddress[];
  onCancel: () => void;
  onSubmit: (value: IAddress, onSuccess: () => void) => void;
  onCreateClick: () => void;
}

export const SubdivisionAddAddressModal: FC<IComponentProps> = ({ open, loading, list, onCancel, onSubmit, onCreateClick }) => {
  const [search, setSearch] = useState<string>('');

  const filteredList = list.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));

  const onSearchChange = async (value = '') => {
    setSearch(value);
  };

  const handleCancel = () => {
    if (loading) {
      return;
    }

    setSearch('');
    onCancel();
  };

  const handleSubmit = (value: IAddress) => {
    onSubmit(value, handleCancel);
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={480}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      closeIcon={false}
      classNames={{ footer: 'justify-between' }}
      footer={[
        <Button
          key="create"
          className="button-text dark-green"
          icon={<Plus className="icon-plus-dark-green" />}
          onClick={onCreateClick}
          loading={loading}
        >
          Новый адрес
        </Button>,
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
      ]}
    >
      <div className="mb-3 ff-medium fs-m">Выберите адрес</div>
      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Добавьте адрес из списка в подразделение, чтобы использовать его при создании заказа.
      </div>
      <div className="mb-6">
        <SearchInput
          auto
          placeholder="Поиск по адресам"
          minLength={DEFAULT_VALUE_0}
          clearDeps={[open]}
          onSearch={onSearchChange}
        />
      </div>
      <div className="pb-3 overflow-y-scroll scrollbar subdivision-add-address-modal__list">
        {filteredList.map((item, index, array) => {
          return (
            <div key={item.id}>
              <div
                className="p-3 flex align-start gap-4 cursor-pointer subdivision-add-address-modal__item"
                onClick={() => handleSubmit(item)}
              >
                <IconBackground content={<Delivery className="icon-delivery-dark-grey" />} color={EColor.LightGrey} />

                <span className="flex-1 ff-regular fs-s ellipsis-2">{item.name}</span>
              </div>

              {index !== array.length - 1 && <Divider marginY={8} />}
            </div>
          );
        })}
      </div>
    </Modal>
  );
};
